export default "__VITE_ASSET__DhDW4PmN__"